import React, { Component } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { withRouter, RouteComponentProps } from "react-router-dom";
import axios from "axios";
import { Link } from "react-router-dom";
import { FileTextOutlined } from "@ant-design/icons";
import { JS_COOKIE } from "util/auth";
import { getCloudFrontSignedUrl } from "util/Downloader";
import api_address from "constants/config";
import { GET_TITLE_BAR } from "util/common";
import CoachLayout from "./Layout";
import VideoPlayerModal from "../common/VideoPlayerModal";
import { PRODUCTS_WITH_REPORT } from "constants/common";
import { ActionTitle, UserComment } from "styles";
import {
  Table,
  ActionButton,
  HeaderTitleContainer,
  BodyContent,
  HeaderRow,
  BodyRow,
  HeaderText,
  ScrollContainer,
  TableContainer,
  ReportNotNeededLabel,
} from "../Therapist/CasePanel/styles";
import AssessmentModal from "components/Therapist/CasePanel/AssessmentModal";

interface CoachProps {
  history: any;
}

type AssignmentType = {
  id: number;
  UUID: string;
  result_id: number;
  video_id: number;
  coach_id: number;
  video1: string;
  video1comment: string;
  video2: string;
  video2comment: string;
  comment: string;
  completed: boolean;
  currentstep: string;
  steps: {
    child_info: {
      childName: string;
    };
  };
  userId: number;
  useruuid: string;
  transactionid: string;
  product_name?: string;
  createdat?: string;
  childname?: string;
  status?: string;
  video1aws?: boolean;
  video2aws?: boolean;
  child_firstName?: string;
  child_lastName?: string;
};

interface CoachState {
  assignments: Array<AssignmentType>;
  loading: boolean;
  error: string | null;
  coachInfo: any;
  videoUrl: string;
  showVideo: boolean;
  selectedUserId: number | null;
  selectedUserUUID: string | null;
  showAssessmentModal: boolean;
  userAssessments: { [key: number]: boolean };
}

type Props = CoachProps & WithTranslation & RouteComponentProps;

class Coach extends Component<Props, CoachState> {
  constructor(props: Props) {
    super(props);
    this.state = {
      assignments: [],
      loading: true,
      error: null,
      coachInfo: null,
      videoUrl: "",
      selectedUserId: null,
      selectedUserUUID: null,
      showVideo: false,
      showAssessmentModal: false,
      userAssessments: {},
    };
  }

  componentDidMount() {
    const { t } = this.props;
    document.title = GET_TITLE_BAR(t, "dashboard", true);
    this.loadCoachData();
  }

  loadCoachData = async () => {
    try {
      this.setState({ loading: true, error: null });

      const token = JS_COOKIE.get("token");

      const response = await axios.get(`${api_address}api/coach/assignments`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const assignments = response.data.assignments || [];
      console.log("assignments", assignments);
      // Check assessments for each user (similar to therapist)
      const userAssessments: { [key: number]: boolean } = {};
      for (const assignment of assignments) {
        if (assignment.userid) {
          try {
            const assessmentRes = await axios.get(
              `${api_address}api/therapist/user-assessment-list/${assignment.userid}`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );
            console.log("assessmentRes.data", assessmentRes.data);
            userAssessments[assignment.userid] =
              assessmentRes.data.userAssessmentList.length > 0;
          } catch (err) {
            console.error(
              "Error checking assessments for user:",
              assignment.userid,
              err
            );
            userAssessments[assignment.userid] = false;
          }
        }
      }

      this.setState({
        assignments,
        coachInfo: response.data.coach || null,
        userAssessments,
        loading: false,
      });
    } catch (error: any) {
      console.error("Error loading coach data:", error);
      this.setState({
        error: error.response?.data?.message || "Failed to load coach data",
        loading: false,
      });
    }
  };

  getVideo = (transactionId: string, video: string, isAWS: boolean = true) => {
    const url = isAWS ? getCloudFrontSignedUrl(transactionId, video) : video;
    this.setState({
      videoUrl: url,
      showVideo: true,
    });
  };

  videoButton = (
    transactionId: string,
    video: string,
    isAWS: boolean = true
  ) => {
    const { t } = this.props;
    if (!video) return <span style={{ color: "#999" }}>No video</span>;

    return (
      <ActionButton
        onClick={() => {
          if (isAWS) {
            this.getVideo(transactionId, video, isAWS);
          } else {
            window.open(video, "_blank");
          }
        }}
      >
        <ActionTitle>{t("therapist.casePanel.watchButton")}</ActionTitle>
      </ActionButton>
    );
  };

  resultButton = (resultId: number) => {
    const { t } = this.props;
    return (
      <Link to={`/full-result/${resultId}`} target="_blank">
        <ActionButton>
          <ActionTitle>{t("therapist.casePanel.readButton")}</ActionTitle>
        </ActionButton>
      </Link>
    );
  };

  reportButton = (transactionId: string) => {
    const { t } = this.props;
    return (
      <Link to={`/core-report/${transactionId}`} target="_blank">
        <ActionButton>
          <ActionTitle>{t("therapist.casePanel.readButton")}</ActionTitle>
        </ActionButton>
      </Link>
    );
  };

  previewButton = (resultId: number) => {
    const { t } = this.props;
    return (
      <Link to={`/core-pro-report/${resultId}`} target="_blank">
        <ActionButton>
          <ActionTitle>{t("therapist.casePanel.readButton")}</ActionTitle>
        </ActionButton>
      </Link>
    );
  };

  reportNotNeededButton = () => {
    return <ReportNotNeededLabel>N/A</ReportNotNeededLabel>;
  };

  handleAssessmentClick = (userId: number, userUUID: string) => {
    this.setState({
      showAssessmentModal: true,
      selectedUserId: userId,
      selectedUserUUID: userUUID,
    });
  };

  handleCloseAssessmentModal = () => {
    this.setState({
      showAssessmentModal: false,
      selectedUserId: null,
      selectedUserUUID: null,
    });
  };

  closeModal = () => {
    if (this.state.showVideo) {
      this.setState({
        showVideo: false,
      });
    }
  };

  headerContent = (data: string) => {
    const { t } = this.props;
    return (
      <HeaderTitleContainer>
        <HeaderText>{t(`therapist.casePanel.${data}`)}</HeaderText>
      </HeaderTitleContainer>
    );
  };

  tableData = (): JSX.Element[] => {
    const { t } = this.props;
    const { assignments, userAssessments } = this.state;
    console.log("userAssessments", assignments);
    return assignments.map((assignment, index) => {
      const {
        result_id,
        video1,
        video1comment,
        video1aws,
        video2,
        video2comment,
        video2aws,
        status,
        completed,
        transactionid,
        product_name,
        id,
        UUID,
        childname,
      } = assignment;
      return (
        <BodyRow key={index}>
          {/* Eval ID */}
          <BodyContent>{result_id}</BodyContent>

          {/* Child Name */}
          <BodyContent>{childname}</BodyContent>

          {/* Video 1 */}
          <BodyContent>
            {this.videoButton(transactionid, video1, video1aws)}
          </BodyContent>

          {/* Video 1 Comment */}
          <BodyContent>
            <UserComment>{video1comment || ""}</UserComment>
          </BodyContent>

          {/* Video 2 */}
          <BodyContent>
            {this.videoButton(
              transactionid || result_id.toString(),
              video2,
              video2aws
            )}
          </BodyContent>

          {/* Video 2 Comment */}
          <BodyContent>
            <UserComment>{video2comment || ""}</UserComment>
          </BodyContent>

          {/* Questionnaire */}
          <BodyContent>{this.resultButton(result_id)}</BodyContent>

          {/* Initial Results */}
          <BodyContent>
            {this.reportButton(transactionid || result_id.toString())}
          </BodyContent>

          {/* Status */}
          <BodyContent>{status}</BodyContent>

          {/* Assessment */}
          <BodyContent>
            {userAssessments[id] && (
              <FileTextOutlined
                style={{ fontSize: 20, cursor: "pointer" }}
                onClick={() => this.handleAssessmentClick(id, UUID)}
                rev={undefined}
              />
            )}
          </BodyContent>

          {/*Report */}
          <BodyContent>{this.previewButton(result_id)}</BodyContent>
        </BodyRow>
      );
    });
  };

  render() {
    const { t } = this.props;
    const {
      loading,
      error,
      coachInfo,
      videoUrl,
      showVideo,
      showAssessmentModal,
      selectedUserId,
      selectedUserUUID,
    } = this.state;

    if (loading) {
      return (
        <CoachLayout>
          <div style={{ textAlign: "center", padding: "50px" }}>
            <div>Loading...</div>
          </div>
        </CoachLayout>
      );
    }

    if (error) {
      return (
        <CoachLayout>
          <div style={{ color: "red", padding: "20px" }}>Error: {error}</div>
        </CoachLayout>
      );
    }

    return (
      <CoachLayout>
        <VideoPlayerModal
          show={showVideo}
          videoUrl={videoUrl}
          closeModal={this.closeModal}
        />

        <AssessmentModal
          show={showAssessmentModal}
          userId={selectedUserId || 0}
          userUUID={selectedUserUUID || ""}
          onClose={this.handleCloseAssessmentModal}
        />

        <TableContainer>
          {coachInfo && (
            <div style={{ padding: "24px" }}>
              <h2>
                {t("coach.welcome", {
                  name: `${coachInfo.firstName} ${coachInfo.lastName}`,
                })}
              </h2>
              <p>{t("coach.dashboard_description")}</p>
            </div>
          )}
          <ScrollContainer>
            <Table>
              <HeaderRow>
                {this.headerContent("id")}
                {this.headerContent("childname")}
                {this.headerContent("video1")}
                {this.headerContent("video1comment")}
                {this.headerContent("video2")}
                {this.headerContent("video2comment")}
                {this.headerContent("result")}
                {this.headerContent("CDEReport")}
                {this.headerContent("status")}
                {this.headerContent("userAssessment")}
                {this.headerContent("report")}
              </HeaderRow>
              {this.tableData()}
            </Table>
          </ScrollContainer>
        </TableContainer>
      </CoachLayout>
    );
  }
}

export default withRouter(withTranslation()(Coach));
